import Vue from 'vue'

const defaultColumns = ['name', 'change24h', 'priceFiat', 'relativeBoughtFiat', 'profitFiat']

const reactiveData = new Vue({
    data: {
        pfCols: JSON.parse(localStorage.getItem('portfolioColumns') || JSON.stringify(defaultColumns)),
        showSoldItems: JSON.parse(localStorage.getItem('showSoldItems') || 'false'),
    }
})

export default {

    get visibleColumnsWithSettings(){
        const portfolioColumns = this.visibleColumns
        return portfolioColumns.map(column => {
            return {
                column,
                settings: this.columnsWithSettings[column],
            }
        })
    },
    get visibleColumns(){
        return reactiveData.$data.pfCols
    },
    setVisibleColumns(columns){
        localStorage.setItem('portfolioColumns', JSON.stringify(columns))
        reactiveData.$data.pfCols = columns
    },

    get availableColumns(){
        return Object.keys(this.columnsWithSettings)
    },
    get columnsWithSettings(){
        return columnsWithSettings
    },

    get showSoldItems(){
        return reactiveData.$data.showSoldItems
    },
    set showSoldItems(value){
        localStorage.setItem('showSoldItems', value)
        reactiveData.$data.showSoldItems = value
    },
}

const columnsWithSettings = {
    'name': {
        title: 'Name',
        info: 'The asset name',
    },
    'change24h': {
        title: '24h',
        decimals: 2,
        suffix: '%',
        info: 'This shows the price change since 24h ago.',
        class: (value) => value < 0 ? 'text-red' : 'text-green',
        hideWhenSold: true,
    },
    'priceFiat': {
        title: 'Current price',
        decimals: 5,
        prefix: '$ ',
        info: 'This is the current price for a single coin/token in USD.',
        hideWhenSold: true,
    },
    'averagePaidForSingleCoin': {
        title: 'Avg paid per coin',
        decimals: 5,
        prefix: '$ ',
        info: 'The average amount of USD paid per current holding coin.\n(This takes sell orders into account. The date time of buy and sell orders are important here.)',
        hideWhenSold: true,
    },
    'holdQuantity': {
        title: 'Quantity',
        decimals: 5,
        info: "This shows how many coins/tokens you're currently holding.",
        hideWhenSold: true,
    },
    'relativeBoughtFiat': {
        title: 'Original worth',
        decimals: 2,
        prefix: '$ ',
        info: 'This indicates the sum of how much the current holding coins were worth at the time of buying.\nExample: bought coin on 1$, 3$ and 5$ -> sold 1 coin afterwards will result in a value of 6 (average price for the 2 leftover coins).',
        hideWhenSold: true,
    },
    'totalBoughtFiat': {
        title: 'Total bought',
        decimals: 2,
        prefix: '$ ',
        info: 'The amount of USD spent on buy orders.',
    },
    'totalSoldFiat': {
        title: 'Total sold',
        decimals: 2,
        prefix: '$ ',
        info: 'The amount of USD retreived on sell orders.',
    },
    'totalInvested': {
        title: 'Total invested',
        decimals: 2,
        prefix: '$ ',
        info: 'This column shows the difference between the total bought and the total sold columns.\nIn other words, it shows how much USD you effectively spent on this coin over all time.',
    },
    'currentWorth': {
        title: 'Current worth',
        decimals: 2,
        prefix: '$ ',
        info: "The amount of USD value you're currently holding.",
        hideWhenSold: true,
    },
    'profitFiat': {
        title: 'Current profit',
        decimals: 2,
        prefix: '$ ',
        info: "This is the profit on the coins/tokens you're currently still holding.\n(This column can be used to base your decisions on)",
        class: (value) => value < 0 ? 'text-red' : 'text-green',
        hideWhenSold: true,
    },
    'totalProfitFiat': {
        title: 'Total profit',
        decimals: 2,
        prefix: '$ ',
        info: "This is the profit on all coins/tokens you've ever bought.\n(This column is historical data and should not be used to base your decisions on)",
        class: (value) => value < 0 ? 'text-red' : 'text-green',
    },
    'profitPercentage': {
        title: 'Current profit (%)',
        decimals: 2,
        suffix: '%',
        info: "This is the profit on the coins/tokens you're currently still holding relative to their purchase price.\n(This column can be used to base your decisions on)",
        class: (value) => value < 0 ? 'text-red' : 'text-green',
        hideWhenSold: true,
    },
    'totalProfitPercentage': {
        title: 'Total profit (%)',
        decimals: 2,
        suffix: '%',
        info: "This is the profit on all coins/tokens you've ever bought relative to their purchase price.\n(This column is historical data and should not be used to base your decisions on)",
        class: (value) => value < 0 ? 'text-red' : 'text-green',
    },
    'pfWeight': {
        title: 'Weight',
        decimals: 2,
        suffix: '%',
        info: 'The amount of USD worth compared to the other assets in the portfolio. (Expressed in %)',
        hideWhenSold: true,
    },
    'daysSinceInitialBuy': {
        title: 'Hodl days',
        info: "This is the earliest date you bought the coin/token (starting from the last time you didn't hold this coin/token).",
        hideWhenSold: true,
    },
}